import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './config/axios'  // Importa a configuração do axios
import 'react-toastify/dist/ReactToastify.css';

// Desabilita logs do React no ambiente de desenvolvimento
if (process.env.NODE_ENV === 'development') {
  const noop = () => {};
  // console.log = noop;
  // console.warn = noop;
  // console.error = noop;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
